import { createStyles, Theme } from '@material-ui/core/styles';

const CustomizedSnackbarsStyles = (theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
    },
    snackBar: {
      maxWidth: '400px',
    },
  });

export default CustomizedSnackbarsStyles;
